import LinearProgress from "@mui/material/LinearProgress";
import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthShell } from "../register/auth-shell";
import "../register/auth-ui.css";
import { showOrToast } from "../shared_modules/ui/components/atoms/or-toast/or-toast";
import { useUserRepository } from "../user/useUserRepository";
import { parseSocialIntent } from "../social-auth/social-intent";

export default function EmailValidator({ redirectTarget = "/login" } = {}) {
  const { validateEmail } = useUserRepository();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  useEffect(() => {
    if (token) {
      validate();
    } else {
      navigate(redirectTarget);
    }
  }, [token]);

  const validate = async () => {
    try {
      let result = await validateEmail({
        token: token,
      });

      if (result) {
        showOrToast("¡Email validado!");
        const intent = redirectTarget === "/login?social=true" && parseSocialIntent(searchParams.get("intent"));
        if (intent) {
          const params = new URLSearchParams({ social: "true", intent });
          const email = typeof result === "object" && typeof result.email === "string" ? result.email : null;
          if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) params.set("email", email);
          navigate(`/login?${params.toString()}`);
        } else {
          navigate(redirectTarget);
        }
      } else {
        showOrToast("No hemos podido validar el email", { type: "error" });
        navigate(redirectTarget);
      }
    } catch (error) {
      showOrToast("Error al validar el email", { type: "error" });
      navigate(redirectTarget);
    }
  };

  return (
    <AuthShell
      title="Validando tu cuenta"
      subtitle="Estamos confirmando tu dirección de correo electrónico, por favor espera un momento."
      footer={
        <>
          <p className="or-auth-form__hint">
            ¿Ya estás registrado? <Link to="/login">Inicia sesión</Link>
          </p>
          <a href="https://openreferences.com/aviso-legal/" target="_blank" rel="noreferrer">
            Términos y Condiciones
          </a>
        </>
      }
    >
      <div className="or-auth-loading">
        <LinearProgress />
      </div>
    </AuthShell>
  );
}
